import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as navigationIcon } from '../../../images/assistant-navigation.svg';

export const AssistantNavigationIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={navigationIcon} />
);

export default AssistantNavigationIcon;
